!function ( e, t ) {"object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define( [], t ) : "object" == typeof exports ? exports.Drawflow = t() : e.Drawflow = t()}( "undefined" != typeof self ? self : this, (function () {
	return function ( e ) {
		var t = {};
		
		function n( i ) {
			if ( t[i] ) return t[i].exports;
			var s = t[i] = { i: i, l: !1, exports: {} };
			return e[i].call( s.exports, s, s.exports, n ), s.l = !0, s.exports
		}
		
		return n.m = e, n.c = t, n.d = function ( e, t, i ) {
			n.o( e, t ) || Object.defineProperty( e, t, {
				enumerable: !0,
				get: i
			} )
		}, n.r = function ( e ) {"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty( e, Symbol.toStringTag, { value: "Module" } ), Object.defineProperty( e, "__esModule", { value: !0 } )}, n.t = function ( e, t ) {
			if ( 1 & t && (e = n( e )), 8 & t ) return e;
			if ( 4 & t && "object" == typeof e && e && e.__esModule ) return e;
			var i = Object.create( null );
			if ( n.r( i ), Object.defineProperty( i, "default", {
				enumerable: !0,
				value: e
			} ), 2 & t && "string" != typeof e ) for ( var s in e ) n.d( i, s, function ( t ) {return e[t]}.bind( null, s ) );
			return i
		}, n.n = function ( e ) {
			var t = e && e.__esModule ? function () {return e.default} : function () {return e};
			return n.d( t, "a", t ), t
		}, n.o = function ( e, t ) {return Object.prototype.hasOwnProperty.call( e, t )}, n.p = "", n( n.s = 0 )
	}( [function ( e, t, n ) {
		"use strict";
		n.r( t ), n.d( t, "default", (function () {return i}) );
		
		class i {
			constructor( e, t = null ) {
				this.events = {}, this.container = e, this.precanvas = null, this.nodeId = 0, this.ele_selected = null, this.node_selected = null, this.drag = !1, this.reroute = !1, this.reroute_fix_curvature = !1, this.curvature = .5, this.reroute_curvature_start_end = .5, this.reroute_curvature = .5, this.reroute_width = 6, this.drag_point = !1, this.editor_selected = !1, this.connection = !1, this.connection_ele = null, this.connection_selected = null, this.canvas_x = 0, this.canvas_y = 0, this.pos_x = 0, this.pos_x_start = 0, this.pos_y = 0, this.pos_y_start = 0, this.mouse_x = 0, this.mouse_y = 0, this.line_path = 5, this.first_click = null, this.force_first_input = !1, this.draggable_inputs = !0, this.useuuid = !1, this.select_elements = null, this.noderegister = {}, this.render = t, this.drawflow = { drawflow: { Home: { data: {} } } }, this.module = "Home", this.editor_mode = "edit", this.zoom = 1, this.zoom_max = 1.6, this.zoom_min = .5, this.zoom_value = .1, this.zoom_last_value = 1, this.evCache = new Array, this.prevDiff = -1
			}
			
			start () {
				// console.info("Start Drawflow!!");
				this.container.classList.add("parent-drawflow");
				this.container.tabIndex = 0;
				this.precanvas = document.createElement('div');
				this.precanvas.classList.add("drawflow");
				this.container.appendChild(this.precanvas);
				
				
				/* Mouse and Touch Actions */
				
				this.container.addEventListener('mouseup', this.dragEnd.bind(this));
				this.container.addEventListener('mousemove', this.position.bind(this));
				this.container.addEventListener('mousedown', this.click.bind(this) );
				
				this.container.addEventListener('touchend', this.dragEnd.bind(this));
				this.container.addEventListener('touchmove', this.position.bind(this));
				this.container.addEventListener('touchstart', this.click.bind(this));
				
				/* Context Menu */
				this.container.addEventListener('contextmenu', this.contextmenu.bind(this));
				/* Delete */
				this.container.addEventListener('keydown', this.key.bind(this));
				
				/* Zoom Mouse */
				this.container.addEventListener('wheel', this.zoom_enter.bind(this));
				/* Update data Nodes */
				this.container.addEventListener('input', this.updateNodeValue.bind(this));
				
				this.container.addEventListener('dblclick', this.dblclick.bind(this));
				/* Mobile zoom */
				this.container.onpointerdown = this.pointerdown_handler.bind(this);
				this.container.onpointermove = this.pointermove_handler.bind(this);
				this.container.onpointerup = this.pointerup_handler.bind(this);
				this.container.onpointercancel = this.pointerup_handler.bind(this);
				this.container.onpointerout = this.pointerup_handler.bind(this);
				this.container.onpointerleave = this.pointerup_handler.bind(this);
				
				this.load();
			}
			
			pointerdown_handler( e ) {this.evCache.push( e )}
			
			pointermove_handler( e ) {
				for ( var t = 0; t < this.evCache.length; t++ ) if ( e.pointerId == this.evCache[t].pointerId ) {
					this.evCache[t] = e;
					break
				}
				if ( 2 == this.evCache.length ) {
					var n = Math.abs( this.evCache[0].clientX - this.evCache[1].clientX );
					this.prevDiff > 100 && (n > this.prevDiff && this.zoom_in(), n < this.prevDiff && this.zoom_out()), this.prevDiff = n
				}
			}
			
			pointerup_handler( e ) {this.remove_event( e ), this.evCache.length < 2 && (this.prevDiff = -1)}
			
			remove_event( e ) {
				for ( var t = 0; t < this.evCache.length; t++ ) if ( this.evCache[t].pointerId == e.pointerId ) {
					this.evCache.splice( t, 1 );
					break
				}
			}
			
			load() {
				for ( var e in this.drawflow.drawflow[this.module].data ) this.addNodeImport( this.drawflow.drawflow[this.module].data[e], this.precanvas );
				if ( this.reroute ) for ( var e in this.drawflow.drawflow[this.module].data ) this.addRerouteImport( this.drawflow.drawflow[this.module].data[e] );
				for ( var e in this.drawflow.drawflow[this.module].data ) this.updateConnectionNodes( "node-" + e );
				const t = this.drawflow.drawflow;
				let n = 1;
				Object.keys( t ).map( (function ( e, i ) {Object.keys( t[e].data ).map( (function ( e, t ) {parseInt( e ) >= n && (n = parseInt( e ))}) )}) ), this.nodeId = n
			}
			
			removeReouteConnectionSelected() {this.dispatch( "connectionUnselected", !0 ), this.reroute_fix_curvature && this.connection_selected.parentElement.querySelectorAll( ".main-path" ).forEach( ( e, t ) => {e.classList.remove( "selected" )} )}
			
			async click( e ) {
				if ( this.dispatch( "click", e ), "fixed" === this.editor_mode ) {
					if ( "parent-drawflow" !== e.target.classList[0] && "drawflow" !== e.target.classList[0] ) return !1;
					this.ele_selected = e.target.closest( ".parent-drawflow" )
				} else "view" === this.editor_mode ? (null != e.target.closest( ".drawflow" ) || e.target.matches( ".parent-drawflow" )) && (this.ele_selected = e.target.closest( ".parent-drawflow" ), e.preventDefault()) : (this.first_click = e.target, this.ele_selected = e.target, 0 === e.button && this.contextmenuDel(), null != e.target.closest( ".drawflow_content_node" ) && (this.ele_selected = e.target.closest( ".drawflow_content_node" ).parentElement));
				switch ( this.ele_selected.classList[0] ) {
					case"drawflow-node":
						null != this.node_selected && (this.node_selected.classList.remove( "selected" ), this.node_selected != this.ele_selected && this.dispatch( "nodeUnselected", !0 )), null != this.connection_selected && (this.connection_selected.classList.remove( "selected" ), this.removeReouteConnectionSelected(), this.connection_selected = null), this.node_selected != this.ele_selected && this.dispatch( "nodeSelected", this.ele_selected.id.slice( 5 ) ), this.node_selected = this.ele_selected, this.node_selected.classList.add( "selected" ), this.draggable_inputs ? "SELECT" !== e.target.tagName && (this.drag = !0) : "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && "SELECT" !== e.target.tagName && !0 !== e.target.hasAttribute( "contenteditable" ) && (this.drag = !0);
						break;
					case"output":
						this.connection = !0, null != this.node_selected && (this.node_selected.classList.remove( "selected" ), this.node_selected = null, this.dispatch( "nodeUnselected", !0 )), null != this.connection_selected && (this.connection_selected.classList.remove( "selected" ), this.removeReouteConnectionSelected(), this.connection_selected = null);
						var id_output = e.target.parentElement.parentElement.id.slice( 5 );
						var output_class = e.target.classList[1];
						const node = await this.getNodeFromId( id_output )
						if ( node.outputs[output_class].connections.length < 1 ) {
							this.drawConnection( e.target, true );
						} else {
							var tuco = document.createElementNS( "http://www.w3.org/2000/svg", "svg" );
							this.connection_ele = tuco;
							this.connection = false
							break;
						}
						// this.drawConnection( e.target );
						break;
					case"parent-drawflow":
					case"drawflow":
						null != this.node_selected && (this.node_selected.classList.remove( "selected" ), this.node_selected = null, this.dispatch( "nodeUnselected", !0 )), null != this.connection_selected && (this.connection_selected.classList.remove( "selected" ), this.removeReouteConnectionSelected(), this.connection_selected = null), this.editor_selected = !0;
						break;
					case"main-path":
						null != this.node_selected && (this.node_selected.classList.remove( "selected" ), this.node_selected = null, this.dispatch( "nodeUnselected", !0 )), null != this.connection_selected && (this.connection_selected.classList.remove( "selected" ), this.removeReouteConnectionSelected(), this.connection_selected = null), this.connection_selected = this.ele_selected, this.connection_selected.classList.add( "selected" );
						const t = this.connection_selected.parentElement.classList;
						this.dispatch( "connectionSelected", {
							output_id: t[2].slice( 14 ),
							input_id: t[1].slice( 13 ),
							output_class: t[3],
							input_class: t[4]
						} ), this.reroute_fix_curvature && this.connection_selected.parentElement.querySelectorAll( ".main-path" ).forEach( ( e, t ) => {e.classList.add( "selected" )} );
						break;
					case"point":
						this.drag_point = !0, this.ele_selected.classList.add( "selected" );
						break;
					case"drawflow-delete":
						this.node_selected && this.removeNodeId( this.node_selected.id ), this.connection_selected && this.removeConnection(), null != this.node_selected && (this.node_selected.classList.remove( "selected" ), this.node_selected = null, this.dispatch( "nodeUnselected", !0 )), null != this.connection_selected && (this.connection_selected.classList.remove( "selected" ), this.removeReouteConnectionSelected(), this.connection_selected = null)
				}
				"touchstart" === e.type ? (this.pos_x = e.touches[0].clientX, this.pos_x_start = e.touches[0].clientX, this.pos_y = e.touches[0].clientY, this.pos_y_start = e.touches[0].clientY) : (this.pos_x = e.clientX, this.pos_x_start = e.clientX, this.pos_y = e.clientY, this.pos_y_start = e.clientY), this.dispatch( "clickEnd", e )
			}
			
			position(e) {
				if (e.type === "touchmove") {
					var e_pos_x = e.touches[0].clientX;
					var e_pos_y = e.touches[0].clientY;
				} else {
					var e_pos_x = e.clientX;
					var e_pos_y = e.clientY;
				}
				
				
				if(this.connection) {
					this.updateConnection(e_pos_x, e_pos_y);
				}
				if(this.editor_selected) {
					/*if (e.ctrlKey) {
					 this.selectElements(e_pos_x, e_pos_y);
					 } else { */
					x =  this.canvas_x + (-(this.pos_x - e_pos_x))
					y = this.canvas_y + (-(this.pos_y - e_pos_y))
					// console.log(canvas_x +' - ' +pos_x + ' - '+ e_pos_x + ' - ' + x);
					this.dispatch('translate', { x: x, y: y});
					this.precanvas.style.transform = "translate("+x+"px, "+y+"px) scale("+this.zoom+")";
					//}
				}
				if(this.drag) {
					let el = e.srcElement.offsetParent
					let nodes = Array.from(document.querySelectorAll('[id^=node]'))

					for (let i = 0; i < nodes.length; i++) {
						if (nodes[i].id === el.id) {
							nodes[i].style.zIndex = '10'
						} else {
							nodes[i].style.zIndex = '1'
						}
					}

					var x = (this.pos_x - e_pos_x) * this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom);
					var y = (this.pos_y - e_pos_y) * this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom);
					this.pos_x = e_pos_x;
					this.pos_y = e_pos_y;
					
					this.ele_selected.style.top = (this.ele_selected.offsetTop - y) + "px";
					this.ele_selected.style.left = (this.ele_selected.offsetLeft - x) + "px";
					
					this.drawflow.drawflow[this.module].data[this.ele_selected.id.slice(5)].pos_x = (this.ele_selected.offsetLeft - x);
					this.drawflow.drawflow[this.module].data[this.ele_selected.id.slice(5)].pos_y = (this.ele_selected.offsetTop - y);
					
					this.updateConnectionNodes(this.ele_selected.id)
				}
				
				if(this.drag_point) {
					
					var x = (this.pos_x - e_pos_x) * this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom);
					var y = (this.pos_y - e_pos_y) * this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom);
					this.pos_x = e_pos_x;
					this.pos_y = e_pos_y;
					
					var pos_x = this.pos_x * ( this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)) - (this.precanvas.getBoundingClientRect().x * ( this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)));
					var pos_y = this.pos_y * ( this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)) - (this.precanvas.getBoundingClientRect().y * ( this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)));
					
					
					
					this.ele_selected.setAttributeNS(null, 'cx', pos_x);
					this.ele_selected.setAttributeNS(null, 'cy', pos_y);
					
					const nodeUpdate = this.ele_selected.parentElement.classList[2].slice(9)
					const nodeUpdateIn = this.ele_selected.parentElement.classList[1].slice(13);
					const output_class = this.ele_selected.parentElement.classList[3];
					const input_class = this.ele_selected.parentElement.classList[4];
					
					let numberPointPosition = Array.from(this.ele_selected.parentElement.children).indexOf(this.ele_selected)-1;
					
					if(this.reroute_fix_curvature) {
						const numberMainPath = this.ele_selected.parentElement.querySelectorAll(".main-path").length-1
						
						numberPointPosition -= numberMainPath;
						if(numberPointPosition < 0) {
							numberPointPosition = 0;
						}
					}
					
					const nodeId = nodeUpdate.slice(5);
					const searchConnection = this.drawflow.drawflow[this.module].data[nodeId].outputs[output_class].connections.findIndex(function(item,i) {
						return item.node ===  nodeUpdateIn && item.output === input_class;
					});
					
					this.drawflow.drawflow[this.module].data[nodeId].outputs[output_class].connections[searchConnection].points[numberPointPosition] = { pos_x: pos_x, pos_y: pos_y };
					
					const parentSelected = this.ele_selected.parentElement.classList[2].slice(9);
					
					/*this.drawflow.drawflow[this.module].data[this.ele_selected.id.slice(5)].pos_x = (this.ele_selected.offsetLeft - x);
					 this.drawflow.drawflow[this.module].data[this.ele_selected.id.slice(5)].pos_y = (this.ele_selected.offsetTop - y);
					 */
					this.updateConnectionNodes(parentSelected);
				}
				
				if (e.type === "touchmove") {
					this.mouse_x = e_pos_x;
					this.mouse_y = e_pos_y;
				}
				this.dispatch('mouseMove', {x: e_pos_x,y: e_pos_y });
			}
			
			
			async dragEnd( e ) {
				if ( null != this.select_elements && (this.select_elements.remove(), this.select_elements = null), "touchend" === e.type ) var t = this.mouse_x,
					n = this.mouse_y,
					i = document.elementFromPoint( t, n ); else t = e.clientX, n = e.clientY, i = e.target;
				if ( this.drag && (this.pos_x_start == t && this.pos_y_start == n || this.dispatch( "nodeMoved", this.ele_selected.id.slice( 5 ) )), this.drag_point && this.ele_selected.classList.remove( "selected" ), this.editor_selected && (this.canvas_x = this.canvas_x + -(this.pos_x - t), this.canvas_y = this.canvas_y + -(this.pos_y - n), this.editor_selected = !1), !0 === this.connection ) if ( "input" === i.classList[0] || this.force_first_input && (null != i.closest( ".drawflow_content_node" ) || "drawflow-node" === i.classList[0]) ) {
					if ( !this.force_first_input || null == i.closest( ".drawflow_content_node" ) && "drawflow-node" !== i.classList[0] ) s = i.parentElement.parentElement.id, o = i.classList[1]; else {
						if ( null != i.closest( ".drawflow_content_node" ) ) var s = i.closest( ".drawflow_content_node" ).parentElement.id; else var s = i.id;
						if ( 0 === Object.keys( await this.getNodeFromId( s.slice( 5 ) ).inputs ).length ) var o = !1; else var o = "input_1"
					}
					var l = this.ele_selected.parentElement.parentElement.id, c = this.ele_selected.classList[1];
					if ( l !== s && !1 !== o ) {
						if ( 0 === this.container.querySelectorAll( ".connection.node_in_" + s + ".node_out_" + l + "." + c + "." + o ).length ) {
							this.connection_ele.classList.add( "node_in_" + s ), this.connection_ele.classList.add( "node_out_" + l ), this.connection_ele.classList.add( c ), this.connection_ele.classList.add( o );
							var d = s.slice( 5 ), a = l.slice( 5 );
							this.drawflow.drawflow[this.module].data[a].outputs[c].connections.push( {
								node: d,
								output: o
							} ), this.drawflow.drawflow[this.module].data[d].inputs[o].connections.push( {
								node: a,
								input: c
							} ), this.updateConnectionNodes( "node-" + a ), this.updateConnectionNodes( "node-" + d ), this.dispatch( "connectionCreated", {
								output_id: a,
								input_id: d,
								output_class: c,
								input_class: o
							} )
						} else this.dispatch( "connectionCancel", !0 ), this.connection_ele.remove();
						this.connection_ele = null
					} else this.dispatch( "connectionCancel", !0 ), this.connection_ele.remove(), this.connection_ele = null
				} else this.dispatch( "connectionCancel", !0 ), this.connection_ele.remove(), this.connection_ele = null;
				this.drag = !1, this.drag_point = !1, this.connection = !1, this.ele_selected = null, this.editor_selected = !1
			}
			
			contextmenu( e ) {
				if ( this.dispatch( "contextmenu", e ), e.preventDefault(), "fixed" === this.editor_mode || "view" === this.editor_mode ) return !1;
				if ( this.precanvas.getElementsByClassName( "drawflow-delete" ).length && this.precanvas.getElementsByClassName( "drawflow-delete" )[0].remove(), this.node_selected || this.connection_selected ) {
					var t = document.createElement( "div" );
					t.classList.add( "drawflow-delete" ), t.innerHTML = "x", this.node_selected && this.node_selected.appendChild( t ), this.connection_selected && (t.style.top = e.clientY * (this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)) - this.precanvas.getBoundingClientRect().y * (this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)) + "px", t.style.left = e.clientX * (this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)) - this.precanvas.getBoundingClientRect().x * (this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)) + "px", this.precanvas.appendChild( t ))
				}
			}
			
			contextmenuDel() {this.precanvas.getElementsByClassName( "drawflow-delete" ).length && this.precanvas.getElementsByClassName( "drawflow-delete" )[0].remove()}
			
			key( e ) {
				if ( this.dispatch( "keydown", e ), "fixed" === this.editor_mode || "view" === this.editor_mode ) return !1;
				("Delete" === e.key || "Backspace" === e.key && e.metaKey) && (null != this.node_selected && "INPUT" !== this.first_click.tagName && "TEXTAREA" !== this.first_click.tagName && !0 !== this.first_click.hasAttribute( "contenteditable" ) && this.removeNodeId( this.node_selected.id ), null != this.connection_selected && this.removeConnection())
			}
			
			zoom_enter( e, t ) { (e.preventDefault(), e.deltaY > 0 ? this.zoom_out() : this.zoom_in())}
			
			zoom_refresh() {this.dispatch( "zoom", this.zoom ), this.canvas_x = this.canvas_x / this.zoom_last_value * this.zoom, this.canvas_y = this.canvas_y / this.zoom_last_value * this.zoom, this.zoom_last_value = this.zoom, this.precanvas.style.transform = "translate(" + this.canvas_x + "px, " + this.canvas_y + "px) scale(" + this.zoom + ")"}
			
			zoom_in() {this.zoom < this.zoom_max && (this.zoom += this.zoom_value, this.zoom_refresh())}
			
			zoom_out() {this.zoom > this.zoom_min && (this.zoom -= this.zoom_value, this.zoom_refresh())}
			
			zoom_reset() {1 != this.zoom && (this.zoom = 1, this.zoom_refresh())}
			
			createCurvature( e, t, n, i, s, o ) {
				var l = e, c = t, d = n, a = i, r = s;
				switch ( o ) {
					case"open":
						if ( e >= n ) var h = l + Math.abs( d - l ) * r,
							u = d - Math.abs( d - l ) * (-1 * r); else h = l + Math.abs( d - l ) * r, u = d - Math.abs( d - l ) * r;
						return " M " + l + " " + c + " C " + h + " " + c + " " + u + " " + a + " " + d + "  " + a;
					case"close":
						if ( e >= n ) h = l + Math.abs( d - l ) * (-1 * r), u = d - Math.abs( d - l ) * r; else h = l + Math.abs( d - l ) * r, u = d - Math.abs( d - l ) * r;
						return " M " + l + " " + c + " C " + h + " " + c + " " + u + " " + a + " " + d + "  " + a;
					case"other":
						if ( e >= n ) h = l + Math.abs( d - l ) * (-1 * r), u = d - Math.abs( d - l ) * (-1 * r); else h = l + Math.abs( d - l ) * r, u = d - Math.abs( d - l ) * r;
						return " M " + l + " " + c + " C " + h + " " + c + " " + u + " " + a + " " + d + "  " + a;
					default:
						return " M " + l + " " + c + " C " + (h = l + Math.abs( d - l ) * r) + " " + c + " " + (u = d - Math.abs( d - l ) * r) + " " + a + " " + d + "  " + a
				}
			}
			drawConnection( e, create ) {
				var t = document.createElementNS( "http://www.w3.org/2000/svg", "svg" );
				this.connection_ele = t;
				var n = document.createElementNS( "http://www.w3.org/2000/svg", "path" );
				n.classList.add( "main-path" ), n.setAttributeNS( null, "d", "" ), t.classList.add( "connection" ), t.appendChild( n ), this.precanvas.appendChild( t );
				var i = e.parentElement.parentElement.id.slice( 5 ), s = e.classList[1];
				
				if(create){
					this.dispatch( "connectionStart", { output_id: i, output_class: s } )
				}
				
			}
			
			updateConnection( e, t ) {
				const n = this.precanvas, i = this.zoom;
				let s = n.clientWidth / (n.clientWidth * i);
				s = s || 0;
				let o = n.clientHeight / (n.clientHeight * i);
				o = o || 0;
				var l = this.connection_ele.children[0],
					
					c = this.ele_selected.offsetWidth / 2 + (this.ele_selected.getBoundingClientRect().x - n.getBoundingClientRect().x) * s,
					d = this.ele_selected.offsetHeight / 2 + (this.ele_selected.getBoundingClientRect().y - n.getBoundingClientRect().y) * o,
					a = e * (this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)) - this.precanvas.getBoundingClientRect().x * (this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)),
					r = t * (this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)) - this.precanvas.getBoundingClientRect().y * (this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)),
					h = this.curvature, u = this.createCurvature( c, d, a, r, h, "openclose" );
				l.setAttributeNS( null, "d", u )
			}
			
		async addConnection( e, t, n, i ) {
				var s = this.getModuleFromNodeId( e );
				if ( s === this.getModuleFromNodeId( t ) ) {
					var o = await this.getNodeFromId( e ), l = !1;

					
					for ( var c in o.outputs[n].connections ) {
						var d = o.outputs[n].connections[c];
						d.node == t && d.output == i && (l = !0)
					}
				if(this.drawflow.drawflow[s].data[t].inputs[i].connections.length>0){
					throw "ERR!"
				}
					if ( !1 === l ) {
						if ( this.drawflow.drawflow[s].data[e].outputs[n].connections.push( {
							node: t.toString(),
							output: i
						} ), this.drawflow.drawflow[s].data[t].inputs[i].connections.push( {
							node: e.toString(),
							input: n
						} ), this.module === s ) {
							var a = document.createElementNS( "http://www.w3.org/2000/svg", "svg" ),
								r = document.createElementNS( "http://www.w3.org/2000/svg", "path" );
							r.classList.add( "main-path" ), r.setAttributeNS( null, "d", "" ), a.classList.add( "connection" ), a.classList.add( "node_in_node-" + t ), a.classList.add( "node_out_node-" + e ), a.classList.add( n ), a.classList.add( i ), await a.appendChild( r ),  await this.precanvas.appendChild( a ), this.updateConnectionNodes( "node-" + e ), this.updateConnectionNodes( "node-" + t )
						}

							this.dispatch( "connectionCreated", {
								output_id: e,
								input_id: t,
								output_class: n,
								input_class: i
							} )

					}
				}
			}
			
			updateConnectionNodes(id) {
				
				// Aquí nos quedamos;
				const idSearch = 'node_in_'+id;
				const idSearchOut = 'node_out_'+id;
				var line_path = this.line_path/2;
				const container = this.container;
				const precanvas = this.precanvas;
				const curvature = this.curvature;
				const createCurvature = this.createCurvature;
				const reroute_curvature = this.reroute_curvature;
				const reroute_curvature_start_end = this.reroute_curvature_start_end;
				const reroute_fix_curvature = this.reroute_fix_curvature;
				const rerouteWidth = this.reroute_width;
				const zoom = this.zoom;
				let precanvasWitdhZoom = precanvas.clientWidth / (precanvas.clientWidth * zoom);
				precanvasWitdhZoom = precanvasWitdhZoom || 0;
				let precanvasHeightZoom = precanvas.clientHeight / (precanvas.clientHeight * zoom);
				precanvasHeightZoom = precanvasHeightZoom || 0;
				
				const elemsOut = container.querySelectorAll(`.${idSearchOut}`);
				
				Object.keys(elemsOut).map(function(item, index) {
					if(elemsOut[item].querySelector('.point') === null) {
						
						var elemtsearchId_out = container.querySelector(`#${id}`);
						
						var id_search = elemsOut[item].classList[1].replace('node_in_', '');
						var elemtsearchId = container.querySelector(`#${id_search}`);
						
						var elemtsearch = elemtsearchId.querySelectorAll('.'+elemsOut[item].classList[4])[0]
						
						var eX = elemtsearch.offsetWidth/2 + (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
						var eY = elemtsearch.offsetHeight/2 + (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
						
						var elemtsearchOut = elemtsearchId_out.querySelectorAll('.'+elemsOut[item].classList[3])[0]
						
						var line_x =  elemtsearchOut.offsetWidth/2 + (elemtsearchOut.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
						var line_y =  elemtsearchOut.offsetHeight/2 + (elemtsearchOut.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
						
						var x = eX;
						var y = eY;
						
						const lineCurve = createCurvature(line_x, line_y, x, y, curvature, 'openclose');
						elemsOut[item].children[0].setAttributeNS(null, 'd', lineCurve );
					} else {
						const points = elemsOut[item].querySelectorAll('.point');
						let linecurve = '';
						const reoute_fix = [];
						points.forEach((item, i) => {
							if(i === 0 && ((points.length -1) === 0)) {
								
								var elemtsearchId_out = container.querySelector(`#${id}`);
								var elemtsearch = item;
								
								var eX =  (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var eY =  (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								
								var elemtsearchOut = elemtsearchId_out.querySelectorAll('.'+item.parentElement.classList[3])[0]
								var line_x =  elemtsearchOut.offsetWidth/2 + (elemtsearchOut.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
								var line_y =  elemtsearchOut.offsetHeight/2 + (elemtsearchOut.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature_start_end, 'open');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
								var elemtsearchId_out = item;
								var id_search = item.parentElement.classList[1].replace('node_in_', '');
								var elemtsearchId = container.querySelector(`#${id_search}`);
								var elemtsearch = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[4])[0]
								
								var elemtsearchIn = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[4])[0]
								var eX =  elemtsearchIn.offsetWidth/2 + (elemtsearchIn.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
								var eY =  elemtsearchIn.offsetHeight/2 + (elemtsearchIn.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
								
								
								var line_x = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var line_y = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature_start_end, 'close');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
							} else if(i === 0) {
								
								var elemtsearchId_out = container.querySelector(`#${id}`);
								var elemtsearch = item;
								
								var eX = (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var eY = (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								
								var elemtsearchOut = elemtsearchId_out.querySelectorAll('.'+item.parentElement.classList[3])[0]
								var line_x =  elemtsearchOut.offsetWidth/2 + (elemtsearchOut.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
								var line_y =  elemtsearchOut.offsetHeight/2 + (elemtsearchOut.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
								
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature_start_end, 'open');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
								// SECOND
								var elemtsearchId_out = item;
								var elemtsearch = points[i+1];
								
								var eX = (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var eY = (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								var line_x = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var line_y = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature, 'other');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
							} else if (i === (points.length -1)) {
								
								var elemtsearchId_out = item;
								
								var id_search = item.parentElement.classList[1].replace('node_in_', '');
								var elemtsearchId = container.querySelector(`#${id_search}`);
								var elemtsearch = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[4])[0]
								
								var elemtsearchIn = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[4])[0]
								var eX =  elemtsearchIn.offsetWidth/2 + (elemtsearchIn.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
								var eY =  elemtsearchIn.offsetHeight/2 + (elemtsearchIn.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
								var line_x = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * (precanvas.clientWidth / (precanvas.clientWidth * zoom)) + rerouteWidth;
								var line_y = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * (precanvas.clientHeight / (precanvas.clientHeight * zoom)) + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature_start_end, 'close');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
							} else {
								var elemtsearchId_out = item;
								var elemtsearch = points[i+1];
								
								var eX = (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * (precanvas.clientWidth / (precanvas.clientWidth * zoom)) + rerouteWidth;
								var eY = (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * (precanvas.clientHeight / (precanvas.clientHeight * zoom)) +rerouteWidth;
								var line_x = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * (precanvas.clientWidth / (precanvas.clientWidth * zoom)) + rerouteWidth;
								var line_y = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * (precanvas.clientHeight / (precanvas.clientHeight * zoom)) + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature, 'other');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
							}
							
						});
						if(reroute_fix_curvature) {
							reoute_fix.forEach((itempath, i) => {
								elemsOut[item].children[i].setAttributeNS(null, 'd', itempath);
							});
							
						} else {
							elemsOut[item].children[0].setAttributeNS(null, 'd', linecurve);
						}
						
					}
				})
				
				const elems = container.querySelectorAll(`.${idSearch}`);
				Object.keys(elems).map(function(item, index) {
					
					if(elems[item].querySelector('.point') === null) {
						var elemtsearchId_in = container.querySelector(`#${id}`);
						
						var id_search = elems[item].classList[2].replace('node_out_', '');
						var elemtsearchId = container.querySelector(`#${id_search}`);
						var elemtsearch = elemtsearchId.querySelectorAll('.'+elems[item].classList[3])[0]
						
						var line_x = elemtsearch.offsetWidth/2 + (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
						var line_y = elemtsearch.offsetHeight/2 + (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
						
						var elemtsearchId_in = elemtsearchId_in.querySelectorAll('.'+elems[item].classList[4])[0]
						var x = elemtsearchId_in.offsetWidth/2 + (elemtsearchId_in.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
						var y = elemtsearchId_in.offsetHeight/2 + (elemtsearchId_in.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
						
						const lineCurve = createCurvature(line_x, line_y, x, y, curvature, 'openclose');
						elems[item].children[0].setAttributeNS(null, 'd', lineCurve );
						
					} else {
						const points = elems[item].querySelectorAll('.point');
						let linecurve = '';
						const reoute_fix = [];
						points.forEach((item, i) => {
							if(i === 0 && ((points.length -1) === 0)) {
								
								var elemtsearchId_out = container.querySelector(`#${id}`);
								var elemtsearch = item;
								
								var line_x = (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var line_y = (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom +rerouteWidth;
								
								var elemtsearchIn = elemtsearchId_out.querySelectorAll('.'+item.parentElement.classList[4])[0]
								var eX =  elemtsearchIn.offsetWidth/2 + (elemtsearchIn.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
								var eY =  elemtsearchIn.offsetHeight/2 + (elemtsearchIn.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
								
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature_start_end, 'close');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
								var elemtsearchId_out = item;
								var id_search = item.parentElement.classList[2].replace('node_out_', '');
								var elemtsearchId = container.querySelector(`#${id_search}`);
								var elemtsearch = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[3])[0]
								
								var elemtsearchOut = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[3])[0]
								var line_x =  elemtsearchOut.offsetWidth/2 + (elemtsearchOut.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
								var line_y =  elemtsearchOut.offsetHeight/2 + (elemtsearchOut.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
								
								var eX = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var eY = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature_start_end, 'open');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
								
							} else if(i === 0) {
								// FIRST
								var elemtsearchId_out = item;
								var id_search = item.parentElement.classList[2].replace('node_out_', '');
								var elemtsearchId = container.querySelector(`#${id_search}`);
								var elemtsearch = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[3])[0]
								var elemtsearchOut = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[3])[0]
								var line_x =  elemtsearchOut.offsetWidth/2 + (elemtsearchOut.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
								var line_y =  elemtsearchOut.offsetHeight/2 + (elemtsearchOut.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
								
								var eX = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var eY = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature_start_end, 'open');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
								// SECOND
								var elemtsearchId_out = item;
								var elemtsearch = points[i+1];
								
								var eX = (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var eY = (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom +rerouteWidth;
								var line_x = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var line_y = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature, 'other');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
							} else if (i === (points.length -1)) {
								
								var elemtsearchId_out = item;
								
								var id_search = item.parentElement.classList[1].replace('node_in_', '');
								var elemtsearchId = container.querySelector(`#${id_search}`);
								var elemtsearch = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[4])[0]
								
								var elemtsearchIn = elemtsearchId.querySelectorAll('.'+item.parentElement.classList[4])[0]
								var eX =  elemtsearchIn.offsetWidth/2 + (elemtsearchIn.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom;
								var eY =  elemtsearchIn.offsetHeight/2 + (elemtsearchIn.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom;
								
								var line_x = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var line_y = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature_start_end, 'close');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
								
							} else {
								
								var elemtsearchId_out = item;
								var elemtsearch = points[i+1];
								
								var eX = (elemtsearch.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var eY = (elemtsearch.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom +rerouteWidth;
								var line_x = (elemtsearchId_out.getBoundingClientRect().x - precanvas.getBoundingClientRect().x ) * precanvasWitdhZoom + rerouteWidth;
								var line_y = (elemtsearchId_out.getBoundingClientRect().y - precanvas.getBoundingClientRect().y ) * precanvasHeightZoom + rerouteWidth;
								var x = eX;
								var y = eY;
								
								var lineCurveSearch = createCurvature(line_x, line_y, x, y, reroute_curvature, 'other');
								linecurve += lineCurveSearch;
								reoute_fix.push(lineCurveSearch);
							}
							
						});
						if(reroute_fix_curvature) {
							reoute_fix.forEach((itempath, i) => {
								elems[item].children[i].setAttributeNS(null, 'd', itempath);
							});
							
						} else {
							elems[item].children[0].setAttributeNS(null, 'd', linecurve);
						}
						
					}
				})
			}
			
			
			dblclick( e ) {null != this.connection_selected && this.reroute && this.createReroutePoint( this.connection_selected ), "point" === e.target.classList[0] && this.removeReroutePoint( e.target )}
			
			createReroutePoint( e ) {
				this.connection_selected.classList.remove( "selected" );
				const t = this.connection_selected.parentElement.classList[2].slice( 9 ),
					n = this.connection_selected.parentElement.classList[1].slice( 13 ),
					i = this.connection_selected.parentElement.classList[3],
					s = this.connection_selected.parentElement.classList[4];
				this.connection_selected = null;
				const o = document.createElementNS( "http://www.w3.org/2000/svg", "circle" );
				o.classList.add( "point" );
				var l = this.pos_x * (this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)) - this.precanvas.getBoundingClientRect().x * (this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)),
					c = this.pos_y * (this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)) - this.precanvas.getBoundingClientRect().y * (this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom));
				o.setAttributeNS( null, "cx", l ), o.setAttributeNS( null, "cy", c ), o.setAttributeNS( null, "r", this.reroute_width );
				let d = 0;
				if ( this.reroute_fix_curvature ) {
					const t = e.parentElement.querySelectorAll( ".main-path" ).length;
					var a = document.createElementNS( "http://www.w3.org/2000/svg", "path" );
					if ( a.classList.add( "main-path" ), a.setAttributeNS( null, "d", "" ), e.parentElement.insertBefore( a, e.parentElement.children[t] ), 1 === t ) e.parentElement.appendChild( o ); else {
						const n = Array.from( e.parentElement.children ).indexOf( e );
						d = n, e.parentElement.insertBefore( o, e.parentElement.children[n + t + 1] )
					}
				} else e.parentElement.appendChild( o );
				const r = t.slice( 5 ),
					h = this.drawflow.drawflow[this.module].data[r].outputs[i].connections.findIndex( (function ( e, t ) {return e.node === n && e.output === s}) );
				void 0 === this.drawflow.drawflow[this.module].data[r].outputs[i].connections[h].points && (this.drawflow.drawflow[this.module].data[r].outputs[i].connections[h].points = []), this.reroute_fix_curvature ? (d > 0 ? this.drawflow.drawflow[this.module].data[r].outputs[i].connections[h].points.splice( d, 0, {
					pos_x: l,
					pos_y: c
				} ) : this.drawflow.drawflow[this.module].data[r].outputs[i].connections[h].points.push( {
					pos_x: l,
					pos_y: c
				} ), e.parentElement.querySelectorAll( ".main-path" ).forEach( ( e, t ) => {e.classList.remove( "selected" )} )) : this.drawflow.drawflow[this.module].data[r].outputs[i].connections[h].points.push( {
					pos_x: l,
					pos_y: c
				} ), this.dispatch( "addReroute", r ), this.updateConnectionNodes( t )
			}
			
			removeReroutePoint( e ) {
				const t = e.parentElement.classList[2].slice( 9 ), n = e.parentElement.classList[1].slice( 13 ),
					i = e.parentElement.classList[3], s = e.parentElement.classList[4];
				let o = Array.from( e.parentElement.children ).indexOf( e ) - 1;
				const l = t.slice( 5 ),
					c = this.drawflow.drawflow[this.module].data[l].outputs[i].connections.findIndex( (function ( e, t ) {return e.node === n && e.output === s}) );
				if ( this.reroute_fix_curvature ) {
					const t = e.parentElement.querySelectorAll( ".main-path" ).length;
					e.parentElement.children[t - 1].remove(), o -= t, o < 0 && (o = 0)
				}
				this.drawflow.drawflow[this.module].data[l].outputs[i].connections[c].points.splice( o, 1 ), e.remove(), this.dispatch( "removeReroute", l ), this.updateConnectionNodes( t )
			}
			
			registerNode(name, html, props = null, options = null) {
				props.parent=[...new Set(props.parent)]
				props.children=[...new Set(props.children)]
				this.noderegister[name] = {html: html, props: props, options: options};
			}
			
		async getNodeFromId( e ) {
				var t = await this.getModuleFromNodeId( e );
				
				return JSON.parse( JSON.stringify( this.drawflow.drawflow[t].data[e] ) )
			}
			
			getNodesFromName( e ) {
				var t = [];
				const n = this.drawflow.drawflow;
				return Object.keys( n ).map( (function ( i, s ) {for ( var o in n[i].data ) n[i].data[o].name == e && t.push( n[i].data[o].id )}) ), t
			}
			
			removeThisNOdeRN( id, name_out ) {
				this.removeNodeOutput( id, name_out )
			}
			
			removeThisNOdeRN2( id, name_out ) {
				this.removeNodeInput( id, name_out )
			}
			
			addNode( id, e, t, n, i, s, o, l, c, d = !1 ) {
				//t input
				//n output
				if ( this.useuuid ) var a = this.getUuid(); else a = Number( id );
				const r = document.createElement( "div" );
				r.classList.add( "parent-node" );
				const h = document.createElement( "div" );
				h.innerHTML = "", h.setAttribute( "id", "node-" + a ), h.classList.add( "drawflow-node" ), "" != o && h.classList.add( o );
				h.style.zIndex = '2'
				const u = document.createElement( "div" );
				u.classList.add( "inputs" );
				const p = document.createElement( "div" );
				p.classList.add( "outputs" );
				const f = {};
				var that = this
				for ( var m = 0; m < t; m++ ) {
				
						const e = document.createElement( "div" );
						e.classList.add( "input" );
						e.classList.add( "input_" + (m + 1) );
						f["input_" + (m + 1)] = { connections: [] };
						var name_out = "input_" + (m + 1)
						var thats = that
					
					if((m + 1)>1){
						e.addEventListener( "click", function ( e ) {thats.removeThisNOdeRN2( id, e.target.className.split( " " )[1] ) }, false )
						
					}
						u.appendChild( e )
				}
				
				if(id){
					const ee = document.createElement( "div" );
					ee.classList.add( "add_input" );
					ee.addEventListener( "click", () => {
						this.addNodeInput( id )
					} )
					u.appendChild( ee )
				}
		
				const g = {};
				var that = this
				for ( m = 0; m < n; m++ ) {
						const e = document.createElement( "div" );
						e.classList.add( "output" );
						e.classList.add( "output_" + (m + 1) );
						g["output_" + (m + 1)] = { connections: [] };
						var name_out = "output_" + (m + 1)
						var thats = that
					if((m + 1)>1) {
						e.addEventListener( "click", function ( e ) {thats.removeThisNOdeRN( id, e.target.className.split( " " )[1] )}, false )
					}
						p.appendChild( e )
					
				}
			//l'utente può aggiungere collegamenti solo se il blocco è domanda
				// const eee = document.createElement( "div" );
				// eee.classList.add( "add_output" );
				// eee.addEventListener( "click", () => {
				// 	this.addNodeOutput( id )
				// } )
				// p.appendChild( eee )
				const _ = document.createElement( "div" );
				if ( _.classList.add( "drawflow_content_node" ), !1 === d ){ _.innerHTML = c;}
				else if ( !0 === d ){ _.appendChild( this.noderegister[c].html.cloneNode( !0 ) ); }
				else if ( 3 === parseInt( this.render.version ) ) {
					//Vue 3
					this.render.createApp( { render: e => this.render.h( this.noderegister[c].html, this.noderegister[c].props, this.noderegister[c].options ) } ).mount( _ )
				} else {
					 // Vue 2
					
					
					let e = new this.render( { render: e => e( this.noderegister[c].html, { props: this.noderegister[c].props } ), ...this.noderegister[c].options } ).$mount();
					_.appendChild( e.$el )
				}

				Object.entries(l).forEach(function (key, value) {
					if(typeof key[1] === "object") {
						insertObjectkeys(null, key[0], key[0]);
					} else {
						var elems = _.querySelectorAll('[df-'+key[0]+']');
						for(var i = 0; i < elems.length; i++) {
							elems[i].value = key[1];
						}
					}
				})

				function insertObjectkeys(object, name, completname) {
					if(object === null) {
						var object = l[name];
					} else {
						var object = object[name]
					}
					if(object !== null) {
						Object.entries(object).forEach(function (key, value) {
							if(typeof key[1] === "object") {
								insertObjectkeys(object, key[0], completname+'-'+key[0]);
							} else {
								var elems = _.querySelectorAll('[df-'+completname+'-'+key[0]+']');
								for(var i = 0; i < elems.length; i++) {
									elems[i].value = key[1];
								}
							}
						});
					}
				}
				h.appendChild(u);
				h.appendChild(_);
				h.appendChild(p);
				h.style.top = s + "px";
				h.style.left =i + "px";
				r.appendChild(h);
				this.precanvas.appendChild(r);
				

				var w = {
					id: a,
					name: e,
					data: l,
					class: o,
					html: c,
					typenode: d,
					inputs: f,
					outputs: g,
					pos_x: i,
					pos_y: s
				};
				return this.drawflow.drawflow[this.module].data[a] = w, this.dispatch( "nodeCreated", a ), this.useuuid || this.nodeId++, a
			}
			
			addNodeImport( e, t ) {
				const n = document.createElement( "div" );
				n.classList.add( "parent-node" );
				const i = document.createElement( "div" );
				i.innerHTML = "", i.setAttribute( "id", "node-" + e.id ), i.classList.add( "drawflow-node" ), "" != e.class && i.classList.add( e.class );
				const s = document.createElement( "div" );
				s.classList.add( "inputs" );
				const o = document.createElement( "div" );
				o.classList.add( "outputs" ), Object.keys( e.inputs ).map( (function ( n, i ) {
					const o = document.createElement( "div" );
					o.classList.add( "input" ), o.classList.add( n ), s.appendChild( o ), Object.keys( e.inputs[n].connections ).map( (function ( i, s ) {
						var o = document.createElementNS( "http://www.w3.org/2000/svg", "svg" ),
							l = document.createElementNS( "http://www.w3.org/2000/svg", "path" );
						l.classList.add( "main-path" ), l.setAttributeNS( null, "d", "" ), o.classList.add( "connection" ), o.classList.add( "node_in_node-" + e.id ), o.classList.add( "node_out_node-" + e.inputs[n].connections[i].node ), o.classList.add( e.inputs[n].connections[i].input ), o.classList.add( n ), o.appendChild( l ), t.appendChild( o )
					}) )
				}) );
				for ( var l = 0; l < Object.keys( e.outputs ).length; l++ ) {
					const e = document.createElement( "div" );
					e.classList.add( "output" ), e.classList.add( "output_" + (l + 1) ), o.appendChild( e )
				}
				const c = document.createElement( "div" );
				if ( c.classList.add( "drawflow_content_node" ), !1 === e.typenode ) c.innerHTML = e.html; else if ( !0 === e.typenode ) c.appendChild( this.noderegister[e.html].html.cloneNode( !0 ) ); else if ( 3 === parseInt( this.render.version ) ) {
					this.render.createApp( { render: t => this.render.h( this.noderegister[e.html].html, this.noderegister[e.html].props, this.noderegister[e.html].options ) } ).mount( c )
				} else {
					let t = new this.render( { render: t => t( this.noderegister[e.html].html, { props: this.noderegister[e.html].props } ), ...this.noderegister[e.html].options } ).$mount();
					c.appendChild( t.$el )
				}
				Object.entries( e.data ).forEach( (function ( t, n ) {
					if ( "object" == typeof t[1] ) !function t( n, i, s ) {
						if ( null === n ) n = e.data[i]; else n = n[i];
						null !== n && Object.entries( n ).forEach( (function ( e, i ) {if ( "object" == typeof e[1] ) t( n, e[0], s + "-" + e[0] ); else for ( var o = c.querySelectorAll( "[df-" + s + "-" + e[0] + "]" ), l = 0; l < o.length; l++ ) o[l].value = e[1]}) )
					}( null, t[0], t[0] ); else for ( var i = c.querySelectorAll( "[df-" + t[0] + "]" ), s = 0; s < i.length; s++ ) i[s].value = t[1]
				}) ), i.appendChild( s ), i.appendChild( c ), i.appendChild( o ), i.style.top = e.pos_y + "px", i.style.left = e.pos_x + "px", n.appendChild( i ), this.precanvas.appendChild( n )
			}
			
			addRerouteImport( e ) {
				const t = this.reroute_width, n = this.reroute_fix_curvature;
				Object.keys( e.outputs ).map( (function ( i, s ) {
					Object.keys( e.outputs[i].connections ).map( (function ( s, o ) {
						const l = e.outputs[i].connections[s].points;
						void 0 !== l && l.forEach( ( o, c ) => {
							const d = e.outputs[i].connections[s].node, a = e.outputs[i].connections[s].output,
								r = document.querySelector( ".connection.node_in_node-" + d + ".node_out_node-" + e.id + "." + i + "." + a );
							if ( n && 0 === c ) for ( var h = 0; h < l.length; h++ ) {
								var u = document.createElementNS( "http://www.w3.org/2000/svg", "path" );
								u.classList.add( "main-path" ), u.setAttributeNS( null, "d", "" ), r.appendChild( u )
							}
							const p = document.createElementNS( "http://www.w3.org/2000/svg", "circle" );
							p.classList.add( "point" );
							var f = o.pos_x, m = o.pos_y;
							p.setAttributeNS( null, "cx", f ), p.setAttributeNS( null, "cy", m ), p.setAttributeNS( null, "r", t ), r.appendChild( p )
						} )
					}) )
				}) )
			}
			
			updateNodeValue( e ) {
				for ( var t = e.target.attributes, n = 0; n < t.length; n++ ) if ( t[n].nodeName.startsWith( "df-" ) ) {
					for ( var i = t[n].nodeName.slice( 3 ).split( "-" ), s = this.drawflow.drawflow[this.module].data[e.target.closest( ".drawflow_content_node" ).parentElement.id.slice( 5 )].data, o = 0; o < i.length - 1; o += 1 ) null == s[i[o]] && (s[i[o]] = {}), s = s[i[o]];
					s[i[i.length - 1]] = e.target.value
				}
			}
			
			
			updateNodeDataFromId(id, data) {
				console.log("sono entrato")
				console.log(data)
				var moduleName = this.getModuleFromNodeId(id)
				this.drawflow.drawflow[moduleName].data[id].data = data;
				if(this.module === moduleName) {
					const content = this.container.querySelector('#node-'+id);
					
					Object.entries(data).forEach(function (key, value) {
						
						console.log(key)
						console.log(value)
						
						
						
						if(typeof key[1] === "object") {
							console.log("if")
							insertObjectkeys(null, key[0], key[0]);
						} else {
							console.log("else")
							var elems = content.querySelectorAll('[df-'+key[0]+']');
							for(var i = 0; i < elems.length; i++) {
								elems[i].value = key[1];
							}
						}
					})
					
					function insertObjectkeys(object, name, completname) {
						if(object === null) {
							var object = data[name];
						} else {
							var object = object[name]
						}
						if(object !== null) {
							Object.entries(object).forEach(function (key, value) {
								if(typeof key[1] === "object") {
									insertObjectkeys(object, key[0], completname+'-'+key[0]);
								} else {
									var elems = content.querySelectorAll('[df-'+completname+'-'+key[0]+']');
									for(var i = 0; i < elems.length; i++) {
										elems[i].value = key[1];
									}
								}
							});
						}
					}
					
				}
			}
			
		async addNodeInput( e ) {
			
	
				var t = this.getModuleFromNodeId( e );
				const n = await this.getNodeFromId( e ), i = Object.keys( n.inputs ).length;
				if ( this.module === t ) {
					const t = document.createElement( "div" );
					t.classList.add( "input" );
					t.classList.add( "input_" + (i + 1) );
					var thats = this
					if ( (i + 1) > 1 ) {
						t.addEventListener( "click", function ( ee ) {thats.removeThisNOdeRN2( e, ee.target.className.split( " " )[1] ) }, false )
					}
					document.querySelector( "#node-" + e + " .inputs" ).appendChild( t );
					this.updateConnectionNodes( "node-" + e )
				}
				this.drawflow.drawflow[t].data[e].inputs["input_" + (i + 1)] = { connections: [] }
			
			
			}
			
			async addNodeOutput( e ) {
				var t = this.getModuleFromNodeId( e );
				const n = await this.getNodeFromId( e ), i = Object.keys( n.outputs ).length;
				if ( this.module === t ) {
					const t = document.createElement( "div" );
					t.classList.add( "output" );
					t.classList.add( "output_" + (i + 1) );
					var thats = this
					if ( (i + 1) > 1 ) {
						t.addEventListener( "click", function ( ee ) {thats.removeThisNOdeRN( e, ee.target.className.split( " " )[1] ) }, false )
					}
					document.querySelector( "#node-" + e + " .outputs" ).appendChild( t );
					this.updateConnectionNodes( "node-" + e );
				}
				this.drawflow.drawflow[t].data[e].outputs["output_" + (i + 1)] = { connections: [] }
			}
			
			async removeNodeInput( e, t ) {
				var n = this.getModuleFromNodeId( e );
				const i = await this.getNodeFromId( e );
				this.module === n && document.querySelector( "#node-" + e + " .inputs .input." + t ).remove();
				const s = [];
				Object.keys( i.inputs[t].connections ).map( (function ( n, o ) {
					const l = i.inputs[t].connections[o].node, c = i.inputs[t].connections[o].input;
					s.push( { id_output: l, id: e, output_class: c, input_class: t } )
				}) ), s.forEach( ( e, t ) => {this.removeSingleConnection( e.id_output, e.id, e.output_class, e.input_class )} ), delete this.drawflow.drawflow[n].data[e].inputs[t];
				const o = [], l = this.drawflow.drawflow[n].data[e].inputs;
				Object.keys( l ).map( (function ( e, t ) {o.push( l[e] )}) ), this.drawflow.drawflow[n].data[e].inputs = {};
				const c = t.slice( 6 );
				let d = [];
				if ( o.forEach( ( t, i ) => {t.connections.forEach( ( e, t ) => {d.push( e )} ), this.drawflow.drawflow[n].data[e].inputs["input_" + (i + 1)] = t} ), d = new Set( d.map( e => JSON.stringify( e ) ) ), d = Array.from( d ).map( e => JSON.parse( e ) ), this.module === n ) {
					document.querySelectorAll( "#node-" + e + " .inputs .input" ).forEach( ( e, t ) => {
						const n = e.classList[1].slice( 6 );
						parseInt( c ) < parseInt( n ) && (e.classList.remove( "input_" + n ), e.classList.add( "input_" + (n - 1) ))
					} )
				}
				d.forEach( ( t, i ) => {
					this.drawflow.drawflow[n].data[t.node].outputs[t.input].connections.forEach( ( i, s ) => {
						if ( i.node == e ) {
							const o = i.output.slice( 6 );
							if ( parseInt( c ) < parseInt( o ) ) {
								if ( this.module === n ) {
									const n = document.querySelector( ".connection.node_in_node-" + e + ".node_out_node-" + t.node + "." + t.input + ".input_" + o );
									n.classList.remove( "input_" + o ), n.classList.add( "input_" + (o - 1) )
								}
								i.points ? this.drawflow.drawflow[n].data[t.node].outputs[t.input].connections[s] = {
									node: i.node,
									output: "input_" + (o - 1),
									points: i.points
								} : this.drawflow.drawflow[n].data[t.node].outputs[t.input].connections[s] = {
									node: i.node,
									output: "input_" + (o - 1)
								}
							}
						}
					} )
				} ), this.updateConnectionNodes( "node-" + e )
			}
			async removeNodeOutput( e, t, safe ) {
				var n = this.getModuleFromNodeId( e );
				const i = await this.getNodeFromId( e );
				this.module === n && document.querySelector( "#node-" + e + " .outputs .output." + t ).remove();
				const s = [];
				Object.keys( i.outputs[t].connections ).map( (function ( n, o ) {
					const l = i.outputs[t].connections[o].node, c = i.outputs[t].connections[o].output;
					s.push( { id: e, id_input: l, output_class: t, input_class: c } )
				}) ), s.forEach( ( e, t ) => {this.removeSingleConnection( e.id, e.id_input, e.output_class, e.input_class )} ), delete this.drawflow.drawflow[n].data[e].outputs[t];
				const o = [], l = this.drawflow.drawflow[n].data[e].outputs;
				Object.keys( l ).map( (function ( e, t ) {o.push( l[e] )}) ), this.drawflow.drawflow[n].data[e].outputs = {};
				const c = t.slice( 7 );
				let d = [];
				if ( o.forEach( ( t, i ) => {
					t.connections.forEach( ( e, t ) => {
						d.push( {
							node: e.node,
							output: e.output
						} )
					} ), this.drawflow.drawflow[n].data[e].outputs["output_" + (i + 1)] = t
				} ), d = new Set( d.map( e => JSON.stringify( e ) ) ), d = Array.from( d ).map( e => JSON.parse( e ) ), this.module === n ) {
					document.querySelectorAll( "#node-" + e + " .outputs .output" ).forEach( ( e, t ) => {
						const n = e.classList[1].slice( 7 );
						parseInt( c ) < parseInt( n ) && (e.classList.remove( "output_" + n ), e.classList.add( "output_" + (n - 1) ))
					} )
				}
				d.forEach( ( t, i ) => {
					this.drawflow.drawflow[n].data[t.node].inputs[t.output].connections.forEach( ( i, s ) => {
						if ( i.node == e ) {
							const o = i.input.slice( 7 );
							if ( parseInt( c ) < parseInt( o ) ) {
								if ( this.module === n ) {
									const n = document.querySelector( ".connection.node_in_node-" + t.node + ".node_out_node-" + e + ".output_" + o + "." + t.output );
									n.classList.remove( "output_" + o ), n.classList.remove( t.output ), n.classList.add( "output_" + (o - 1) ), n.classList.add( t.output );
								}
								i.points ? this.drawflow.drawflow[n].data[t.node].inputs[t.output].connections[s] = {
									node: i.node,
									input: "output_" + (o - 1),
									points: i.points
								} : this.drawflow.drawflow[n].data[t.node].inputs[t.output].connections[s] = {
									node: i.node,
									input: "output_" + (o - 1)
								}
							}
						}
					} )
				} ), this.updateConnectionNodes( "node-" + e )
				var node = await this.getNodeFromId( e );
				if ( Object.keys( node.outputs ).length === 0 && safe != true ) {
					alert( "il nodo deve avere almeno un output" )
					this.addNodeOutput( e )
				}
			}
			
			removeNodeId( e ) {
			
				 this.removeConnectionNodeId( e );
				var t = this.getModuleFromNodeId( e.slice( 5 ) );
			
				this.module === t && this.container.querySelector( "#" + e ).remove(), delete this.drawflow.drawflow[t].data[e.slice( 5 )], this.dispatch( "nodeRemoved", e.slice( 5 ) )
			}
			
			removeConnection() {
				if ( null != this.connection_selected ) {
					var e = this.connection_selected.parentElement.classList;
					this.connection_selected.parentElement.remove();
					var t = this.drawflow.drawflow[this.module].data[e[2].slice( 14 )].outputs[e[3]].connections.findIndex( (function ( t, n ) {return t.node === e[1].slice( 13 ) && t.output === e[4]}) );
					this.drawflow.drawflow[this.module].data[e[2].slice( 14 )].outputs[e[3]].connections.splice( t, 1 );
					var n = this.drawflow.drawflow[this.module].data[e[1].slice( 13 )].inputs[e[4]].connections.findIndex( (function ( t, n ) {return t.node === e[2].slice( 14 ) && t.input === e[3]}) );
					this.drawflow.drawflow[this.module].data[e[1].slice( 13 )].inputs[e[4]].connections.splice( n, 1 ), this.dispatch( "connectionRemoved", {
						output_id: e[2].slice( 14 ),
						input_id: e[1].slice( 13 ),
						output_class: e[3],
						input_class: e[4]
					} ), this.connection_selected = null
				}
			}
			
			removeSingleConnection( e, t, n, i ) {
				var s = this.getModuleFromNodeId( e );
				if ( s === this.getModuleFromNodeId( t ) ) {
					if ( this.drawflow.drawflow[s].data[e].outputs[n].connections.findIndex( (function ( e, n ) {return e.node == t && e.output === i}) ) > -1 ) {
						this.module === s && document.querySelector( ".connection.node_in_node-" + t + ".node_out_node-" + e + "." + n + "." + i ).remove();
						var o = this.drawflow.drawflow[s].data[e].outputs[n].connections.findIndex( (function ( e, n ) {return e.node == t && e.output === i}) );
						this.drawflow.drawflow[s].data[e].outputs[n].connections.splice( o, 1 );
						var l = this.drawflow.drawflow[s].data[t].inputs[i].connections.findIndex( (function ( t, i ) {return t.node == e && t.input === n}) );
						return this.drawflow.drawflow[s].data[t].inputs[i].connections.splice( l, 1 ), this.dispatch( "connectionRemoved", {
							output_id: e,
							input_id: t,
							output_class: n,
							input_class: i
						} ), !0
					}
					return !1
				}
				return !1
			}
				removeSingleConnectionWithoutDispatch( e, t, n, i ) {
				var s = this.getModuleFromNodeId( e );
				if ( s === this.getModuleFromNodeId( t ) ) {
					if ( this.drawflow.drawflow[s].data[e].outputs[n].connections.findIndex( (function ( e, n ) {return e.node == t && e.output === i}) ) > -1 ) {
						this.module === s && document.querySelector( ".connection.node_in_node-" + t + ".node_out_node-" + e + "." + n + "." + i ).remove();
						var o = this.drawflow.drawflow[s].data[e].outputs[n].connections.findIndex( (function ( e, n ) {return e.node == t && e.output === i}) );
						this.drawflow.drawflow[s].data[e].outputs[n].connections.splice( o, 1 );
						var l = this.drawflow.drawflow[s].data[t].inputs[i].connections.findIndex( (function ( t, i ) {return t.node == e && t.input === n}) );
						return this.drawflow.drawflow[s].data[t].inputs[i].connections.splice( l, 1 ), !0
					}
					return !1
				}
				return !1
			}
			
			removeConnectionNodeId( e ) {
				const t = "node_in_" + e, n = "node_out_" + e, i = this.container.querySelectorAll( "." + n );
				for ( var s = i.length - 1; s >= 0; s-- ) {
					var o = i[s].classList,
						l = this.drawflow.drawflow[this.module].data[o[1].slice( 13 )].inputs[o[4]].connections.findIndex( (function ( e, t ) {return e.node === o[2].slice( 14 ) && e.input === o[3]}) );
					this.drawflow.drawflow[this.module].data[o[1].slice( 13 )].inputs[o[4]].connections.splice( l, 1 );
					var c = this.drawflow.drawflow[this.module].data[o[2].slice( 14 )].outputs[o[3]].connections.findIndex( (function ( e, t ) {return e.node === o[1].slice( 13 ) && e.output === o[4]}) );
					this.drawflow.drawflow[this.module].data[o[2].slice( 14 )].outputs[o[3]].connections.splice( c, 1 ), i[s].remove(), this.dispatch( "connectionRemoved", {
						output_id: o[2].slice( 14 ),
						input_id: o[1].slice( 13 ),
						output_class: o[3],
						input_class: o[4]
					} )
				}
				const d = this.container.querySelectorAll( "." + t );
				for ( s = d.length - 1; s >= 0; s-- ) {
					o = d[s].classList, c = this.drawflow.drawflow[this.module].data[o[2].slice( 14 )].outputs[o[3]].connections.findIndex( (function ( e, t ) {return e.node === o[1].slice( 13 ) && e.output === o[4]}) );
					this.drawflow.drawflow[this.module].data[o[2].slice( 14 )].outputs[o[3]].connections.splice( c, 1 );
					l = this.drawflow.drawflow[this.module].data[o[1].slice( 13 )].inputs[o[4]].connections.findIndex( (function ( e, t ) {return e.node === o[2].slice( 14 ) && e.input === o[3]}) );
					this.drawflow.drawflow[this.module].data[o[1].slice( 13 )].inputs[o[4]].connections.splice( l, 1 ), d[s].remove(), this.dispatch( "connectionRemoved", {
						output_id: o[2].slice( 14 ),
						input_id: o[1].slice( 13 ),
						output_class: o[3],
						input_class: o[4]
					} )
				}
			}
			
			getModuleFromNodeId( e ) {
				var t;
				const n = this.drawflow.drawflow;
				return Object.keys( n ).map( (function ( i, s ) {Object.keys( n[i].data ).map( (function ( n, s ) {n == e && (t = i)}) )}) ), t
			}
			
			addModule( e ) {this.drawflow.drawflow[e] = { data: {} }, this.dispatch( "moduleCreated", e )}
			
			changeModule( e ) {this.dispatch( "moduleChanged", e ), this.module = e, this.precanvas.innerHTML = "", this.canvas_x = 0, this.canvas_y = 0, this.pos_x = 0, this.pos_y = 0, this.mouse_x = 0, this.mouse_y = 0, this.zoom = 1, this.zoom_last_value = 1, this.precanvas.style.transform = "", this.import( this.drawflow )}
			
			removeModule( e ) {this.module === e && this.changeModule( "Home" ), delete this.drawflow.drawflow[e], this.dispatch( "moduleRemoved", e )}
			
			clearModuleSelected() {this.precanvas.innerHTML = "", this.drawflow.drawflow[this.module] = { data: {} }}
			
			clear() {this.precanvas.innerHTML = "", this.drawflow = { drawflow: { Home: { data: {} } } }}
			
			export() {
				const e = JSON.parse( JSON.stringify( this.drawflow ) );
				return this.dispatch( "export", e ), e
			}
			
			import( e ) {this.clear(), this.drawflow = JSON.parse( JSON.stringify( e ) ), this.load(), this.dispatch( "import", "import" )}
			
			/* Events */
			on (event, callback) {
				// Check if the callback is not a function
				if (typeof callback !== 'function') {
					console.error(`The listener callback must be a function, the given type is ${typeof callback}`);
					return false;
				}
				
				
				// Check if the event is not a string
				if (typeof event !== 'string') {
					console.error(`The event name must be a string, the given type is ${typeof event}`);
					return false;
				}
				
				// Check if this event not exists
				if (this.events[event] === undefined) {
					this.events[event] = {
						listeners: []
					}
				}
				
				this.events[event].listeners.push(callback);
			}
			removeListener( e, t ) {
				if ( void 0 === this.events[e] ) return !1;
				this.events[e].listeners = this.events[e].listeners.filter( e => e.toString() !== t.toString() )
			}
			
			dispatch (event, details) {
				// Check if this event not exists
				if (this.events[event] === undefined) {
					// console.error(`This event: ${event} does not exist`);
					return false;
				}
				
				this.events[event].listeners.forEach((listener) => {
					listener(details);
				});
			}
			
			
			getUuid() {
				for ( var e = [], t = 0; t < 36; t++ ) e[t] = "0123456789abcdef".substr( Math.floor( 16 * Math.random() ), 1 );
				return e[14] = "4", e[19] = "0123456789abcdef".substr( 3 & e[19] | 8, 1 ), e[8] = e[13] = e[18] = e[23] = "-", e.join( "" )
			}
		}
	}] ).default
}) );
